import { useCallback, useRef, useState } from "react";
import LeftSection from "./LeftSection";
//import LeftSection from "./LeftSection11";
import RightSection from "./RightSection";
import MessageCallingSection from "./MessageCallingSection";
import { useEffect } from "react";
import { useGetState } from "../../context/useGetState";
import FullPageLoader from "../../components/full-page-loader";
import { db } from "../../service/firebase";
import { collection, onSnapshot, query } from "firebase/firestore";
import BottomNavigationForMobile from "./BottomNavigationForMobile";
import { getRandomTraders } from "../dashboard/discover/service";
import {
  allContactsRoute,
  getChatContacts,
  getChatInteractingUsers,
  getInteractingUsers,
  getMessages,
  socketHost,
} from "./service";
import { io } from "socket.io-client";
import axios from "axios";
import { useDisclosure } from "@chakra-ui/hooks";
import { Collapse } from "@chakra-ui/transition";
import { useParams } from "react-router";

function Messaging() {
  const { state } = useGetState();

  const { userInfo, privateChatRecipient } = state;
  const [socketLastObj, setSocketLastObj] = useState(undefined)

  const [incomingLastMessage, setIncomingLastMessage] = useState(undefined);
  const [isSocketConnected, setIsSocketConnected] = useState(true);

  const { privateUserId } = useParams();
  const thePrivateChatUser = localStorage.getItem("privateChatRecipient") ? JSON.parse(localStorage.getItem("privateChatRecipient")) : undefined
  //console.log('thePrivateChatUser: ', thePrivateChatUser);
  //return

  // let thePrivateChatUser
  // if (localStorage.getItem("privateChatRecipient")) {
  //   thePrivateChatUser = undefined
  // } else {
  //   thePrivateChatUser = JSON.parse(localStorage.getItem("privateChatRecipient"))
  // }

  //Fconsole.log('privateChatRecipient: ', thePrivateChatUser);
  
  const [showCall, setShowCall] = useState(false);
  const [chats, setChats] = useState(null);
  const [loading, setLoading] = useState(true);
  const accountType = userInfo?.account_type;
  const [selectedChat, setSelectedChat] = useState(null);
  const [activeState, setActiveState] = useState(0);
  const [receiverCurrentChat, setReceiverCurrentChat] = useState(undefined);

  /////////my-code//////////////////////////////////////

  const [contacts, setContacts] = useState([]);
  const [privateContact, setPrivateContact] = useState();
  const [traders, setTraders] = useState([]);
  const [currentChat, setCurrentChat] = useState(undefined);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [typingUserId, setTypingUserId] = useState();

  const socket = useRef();

  // const authUser = userInfo
  //console.log('socketLastObj: ',socketLastObj);

   // Get the bearer token from sessionStorage
   const token = sessionStorage.getItem('#f8WEB#');

  // Define headers with the bearer token
  const headers = {
    Authorization: `Bearer ${token}`,
    // Other headers if needed
  };

  //add authUser to socket socket, add-user event
  useEffect(() => {
    if (userInfo) {
      socket.current = io(socketHost); //one-to-one
      socket.current.emit("add-user", userInfo?.id); //emit event

      socket.current.on("getOnlineUsers", (res)=>{
        setOnlineUsers(res)
      })
      console.log('getOnlineUsers: ', onlineUsers);
      console.log('authUser: ', userInfo?.id);

      // socket.current.on('typingResponse', (data) => {
      //   setTypingUserId(data)
      //   console.log('initialTyping: ', data)
      // });

      socket.current.on("connect", () => {
        setIsSocketConnected(true);
      });
  
      socket.current.on("disconnect", () => {
        setIsSocketConnected(false);
      });
  
    }

    //clean-up
    return () => {
      socket.current?.off("getOnlineUsers");
    };
  }, [userInfo, socket]);

  useEffect(() => {
    async function fetchContacts() {
      if (thePrivateChatUser) {
        setContacts(thePrivateChatUser); //obj to array
        setLoading(false)
        //console.log('setContacts: ', contacts);
      } else {
        const res = await getChatContacts(setLoading);
        setContacts(res?.data?.data);
        //console.log('setContacts: ', res?.data?.data);
        setLoading(false)
      }
    }
    fetchContacts();
  }, [userInfo, setSocketLastObj]);

  const handleChatChange = (chat) => {
    setCurrentChat(chat);
  };

  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const [isLeftSideVisible, setIsLeftSideVisible] = useState(true);

  const toggleLeftSide = () => {
    setIsLeftSideVisible((prevState) => !prevState);
  };
  return loading ? (
    <FullPageLoader />
  ) : (
    <BottomNavigationForMobile active={activeState}>
      <Collapse in={isOpen}>
        <LeftSection
          contacts={contacts}
          privateContact={privateContact}
          onlineUsers={onlineUsers}
          typingUserId={typingUserId}
          flex={["3", "3", "4", "2"]}
          maxW={["100%", "300px"]}
          w={["100%", "300px"]}
          accountType={accountType}
          chats={chats}
          setChats={setChats}
          privateChatRecipient={thePrivateChatUser}
          setSelectedChat={(data) => {
            console.log("ll");
            setSelectedChat(data);
            setActiveState((prev) => !prev);
          }}
          selectedChat={selectedChat}
          currentChat={currentChat}
          receiverCurrentChat={receiverCurrentChat}
          changeChat={handleChatChange}
          socketLastObj={socketLastObj}
          incomingLastMessage={incomingLastMessage}

          // setShowChatDetails={setShowChatDetails}
        />
      </Collapse>

      {!showCall && (
        <RightSection
          onToggle={onToggle}
          isOpen={isOpen}
          socket={socket}
          typingUserId={typingUserId}
          setReceiverCurrentChat={setReceiverCurrentChat}
          setSocketLastObj={setSocketLastObj}
          setShowCall={setShowCall}
          h={["unset", window.innerHeight - 105]}
          w={["100%", "unset"]}
          accountType={accountType}
          privateChatRecipient={thePrivateChatUser}
          authUser={userInfo}
          chats={chats}
          selectedChat={selectedChat}
          currentChat={currentChat}
          setActiveState={setActiveState}
          setIncomingLastMessage={setIncomingLastMessage}
          setIsSocketConnected={setIsSocketConnected}
          isSocketConnected={isSocketConnected}
        />
      )}
      {showCall && <MessageCallingSection setShowCall={setShowCall} />}
    </BottomNavigationForMobile>
  );
}

export default Messaging;
